// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__hmnYc","box":"WorkspacesBox_box__2RFCu","node":"WorkspacesBox_node__3rktd"};